import { React, BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import AppRoutes from './Routes/appRoutes';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { ToastContainer } from 'react-toastify';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import logo from "../src/EpicGame/Assets/images/pngwing.com.png"

function App() {
  return (
    <>
      <AppRoutes />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* <FloatingWhatsApp
        phoneNumber="+13322692184"
        accountName="Epic Support"
        allowClickAway
        notification
        notificationSound
        message="Hi there! 👋 How can we help you today?"  // ✅ Custom first message
        avatar={logo} // optional
      /> */}

    </>
  );
}

export default App;
